/* eslint-disable jsx-a11y/anchor-is-valid */
import {
  useState,
  useEffect,
  useCallback,
} from 'react'

import { useSelector, shallowEqual, useDispatch } from 'react-redux';
import { Modal } from "react-bootstrap";
import { KTSVG } from '../../../_metronic/helpers';

import LoadingContent from 'app/modules/loading/LoadingContent';

import {
  fetchCredits,
  fetchCreditsGroup,
} from 'app/services/credits';

import {
  fetchDayUseCheckIn,
} from 'app/services/dayUses';

import {
  formatLongDateToDate,
  parseWeekDays,
} from 'app/services/dates';
import { useNavigate } from 'react-router-dom';

interface CheckInDayUseModalProps {
  isOpen: boolean;
  onClosed: () => void;
}

const CheckInDayUseModal = ({ isOpen, onClosed }: CheckInDayUseModalProps) => {
  const { credits, dayUses } = useSelector((state: any) => ({
    credits: state.credits,
    dayUses: state.dayUses,
  }), shallowEqual);

  const dispatch = useDispatch();
  const navigate = useNavigate();

  const [open, setOpen] = useState<boolean>(false);
  const [list, setList] = useState<any>([]);
  const [selectedCredit, setSelectedCredit] = useState<any>(null);
  // const [loading, setLoading] => useState<boolean>(false);

  const loadCredits = useCallback(() => {
    // Buscar apenas créditos disponíveis para day use
    dispatch<any>(fetchCreditsGroup('day_use')).then((value: any) => {
      // Filtrar apenas créditos que estão ativos e disponíveis para uso
      const dayUseCredits = value?.filter((item: any) =>
        item.relationships?.status?.attributes?.name === 'active' &&
        item.attributes?.is_active
      ) || [];
      setList(dayUseCredits);
    });
  }, [dispatch]);

  useEffect(() => {
    setOpen(isOpen);
    if (isOpen) {
      setSelectedCredit(null);
      loadCredits();
    }
  }, [isOpen, loadCredits]);

  const getBranchName = (value: any) => {
    if (value.relationships?.origin?.type === 'plan') {
      return value.relationships?.origin?.relationships?.branches?.[0]?.attributes?.name || '';
    }
    return '';
  };

  const getBranches = (value: any) => {
    if (value.relationships?.origin?.type === 'plan') {
      return value.relationships?.origin?.relationships?.branches || [];
    }
    return [];
  };

  const close = () => {
    setOpen(false);
    setSelectedCredit(null);
    onClosed();
  };

  const handleSelectCredit = (credit: any) => {
    setSelectedCredit(credit);
  };

  const handleCheckIn = () => {
    if (selectedCredit) {
      dispatch<any>(fetchDayUseCheckIn({
        credit_id: selectedCredit.id
      })).then((response: any) => {
        // Sucesso no check-in
        console.log('Check-in realizado com sucesso:', response);
        // Fechar modal e recarregar dados
        close();

        navigate(`/compras/day-use/${response.id}`)
        // Aqui você pode adicionar uma notificação de erro se desejar
      }).catch((error: any) => {
        // Erro no check-in
        console.error('Erro ao realizar check-in:', error);
        // Aqui você pode adicionar uma notificação de erro se desejar
      });
    }
  };

  const showCreditItem = (item: any) => {
    const isSelected = selectedCredit?.id === item.id;

    return (
      <div key={item.id} className="col-12 mb-3">
        <div
          className={`card card-dashed flex-row flex-stack p-4 cursor-pointer ${
            isSelected ? 'border-primary bg-light-primary' : ''
          }`}
          onClick={() => handleSelectCredit(item)}
        >
          <div className="d-flex align-items-center me-2">
            <div className="flex-grow-1">
              <div className="d-flex align-items-center fs-4 fw-bold flex-wrap pb-2">
                {item?.relationships?.origin?.attributes?.name}
              </div>
              <div className="fs-7 fw-semibold text-gray-700 pb-1 d-flex flex-column">
                {getBranches(item).map((branch: any) => <span key={`branch-name-credit-`+branch.id}>{branch.attributes.name}</span>)}
              </div>
              <div className="fs-7 fw-semibold text-white pb-1">
                <span className="text-gray-700 me-1">Dias válidos:</span>
                {parseWeekDays(item.attributes.weekdays, true)}
              </div>
              <div className="fs-7 fw-semibold text-gray-700 pb-1">
                {item.attributes.expired_at
                  ? `Válido até ${formatLongDateToDate(item.attributes.expired_at, true)}`
                  : 'Sem data de válidade'
                }
              </div>
              <div className="fs-7 fw-semibold text-gray-700 pb-1">
              <span className="fs-7 text-note badge bg-primary">{item.attributes.total > 1 ? item.attributes.total + ' créditos' : '1 crédito'}</span>
              </div>
            </div>
          </div>
          <div className="d-flex ms-5 align-items-center">
            {isSelected && (
              <KTSVG
                path="/media/icons/duotune/general/gen043.svg"
                className="svg-icon-2 svg-icon-primary"
              />
            )}
            {!isSelected && (
              <div className="form-check form-check-custom form-check-solid">
                <input
                  className="form-check-input"
                  type="radio"
                  name="credit"
                  readOnly
                />
              </div>
            )}
          </div>
        </div>
      </div>
    );
  };

  return (
    <>
      <Modal
        size="lg"
        aria-labelledby="contained-modal-title-vcenter"
        centered
        backdrop="static"
        keyboard={true}
        show={open}
        onHide={() => close()}
        dialogClassName="custom-modal mw-600px"
        className="bg-black bg-opacity-50"
      >
        <Modal.Header>
          <Modal.Title id="example-modal-sizes-title-lg" className="py-7 flex-root d-flex justify-content-center">
            <h2 className="fd-uppercase">Check-in Day Use</h2>
          </Modal.Title>

          <div className="btn btn-sm btn-icon btn-active-color-primary" onClick={() => close()}>
            <span className="svg-icon svg-icon-1">
              <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <rect opacity="0.5" x="6" y="17.3137" width="16" height="2" rx="1" transform="rotate(-45 6 17.3137)" fill="currentColor" />
                <rect x="7.41422" y="6" width="16" height="2" rx="1" transform="rotate(45 7.41422 6)" fill="currentColor" />
              </svg>
            </span>
          </div>
        </Modal.Header>
        <Modal.Body>
          <div className="w-100 pb-5">
            {credits.listLoading && (
              <div className="d-flex justify-content-center py-10">
                <LoadingContent />
              </div>
            )}

            {!credits.listLoading && list.length === 0 && (
              <div className="text-center py-10">
                <h3 className="mb-3">Nenhum crédito disponível</h3>
                <div className="text-muted fw-semibold fs-5">
                  Você não possui créditos de day use disponíveis para check-in.
                </div>
              </div>
            )}

            {!credits.listLoading && list.length > 0 && (
              <>
                <div className="mb-5">
                  <h4 className="mb-3">Selecione um crédito para check-in:</h4>
                </div>

                <div className="row">
                  {list.map((item: any) => showCreditItem(item))}
                </div>
              </>
            )}

            {/* Botões de ação */}
            <div className="d-flex flex-stack mt-8">
              <div className='me-2'>
                <button
                  type="button"
                  className="btn btn-lg btn-light-primary me-3 btn-active-light-danger"
                  onClick={() => close()}
                >
                  <KTSVG
                    path='/media/icons/duotune/arrows/arr063.svg'
                    className='svg-icon-3 me-1'
                  />{' '}
                  Voltar
                </button>
              </div>
              <div>
                <button
                  type="button"
                  className="btn btn-lg btn-primary"
                  onClick={() => handleCheckIn()}
                  disabled={
                    (!selectedCredit || dayUses.actionsLoading)}
                >
                  {!dayUses.actionsLoading && <>
                    Check-in{' '}
                    <KTSVG
                      path='/media/icons/duotune/arrows/arr064.svg'
                      className='svg-icon-3 ms-2 me-0'
                    />
                  </>}
                  {dayUses.actionsLoading && (
                    <span className="indicator-label">
                      Carregando... <span className="spinner-border spinner-border-sm align-middle ms-2"></span>
                    </span>
                  )}
                </button>
              </div>
            </div>
          </div>
        </Modal.Body>
      </Modal>
    </>
  );
};

export default CheckInDayUseModal;